module.exports = __webpack_public_path__ + "img/onboarding5.91fb44ed.png";